import { styled } from '@/shared/ui';

export const StyledWrapper = styled('div')`
  height: 100vh;
  width: 100vw;
  display: flex;

  background-color: #f3f3f3;
`;

export const StyledBox = styled('div')`
  height: 100%;
  min-height: 600px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
  margin: auto;
`;

export const StyledText = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 700px;

  font-weight: 400;
`;

export const StyledOops = styled('div')`
  font-size: 45px;
`;
